export default __webpack_public_path__ + "static/media/go_back.2debadb3.svg";